import * as React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import Select, { ActionMeta, MultiValue } from 'react-select'

interface ScheduleItems {
    loading: boolean;
    tab: string;
    items: OptionsItem[];
    siteAddressFilter: string;
    customerFilter: string;
    itemFilter: OptionsItem[];
}

interface ScheduleItemsProps {
    scheduleItems: ScheduleItem[];
    install: ScheduleItemDetails[];
    pickup: ScheduleItemDetails[];
    isModal: boolean;
    updateInstalls(data: any): void;
    updatePickups(data: any): void;
    save(data: any): void;
}

interface ScheduleItemDetails {
    itemIndex: number;
    jobQuoteItemId: number;
    jobId: number;
    itemId: number;
    siteAddress: string;
    customer: string;
    item: string;
    status: string;
    quantityTotal: number;
    quantityScheduled: number;
    quantityType: string;
    hirePeriodActual: number;
    hirePeriod: string;
    accountTypeId: number;
    allowOnGoingHire: number;
    chargePublicHoliday: boolean;
    chargeShutdownPeriod: boolean;
    selected: boolean;
    scheduled: boolean;
    showDetail: boolean;
    extraHours: number;
    callout: boolean;
    items: ScheduleRelatedItemDetails[];
    showRedNotes: boolean;
    notes: string;
}

interface ScheduleRelatedItemDetails {
    jobQuoteItemId: number;
    jobId: number;
    itemId: number;
    item: string;
    status: string;
    quantityTotal: number;
    quantityScheduled: number;
    quantityType: string;
    hirePeriod: string;
}

interface OptionsItem {
    label: string;
    value: number;
}

type ScheduleItem = {
    origItemIndex: number;  //index from pickup/install list - if set means we have scheduled and unscheduled without saving
    id: number;
    jobId: number;
    itemId: number;
    item: string;
    jobQuoteItemId: number;
    type: string;
    typeId: number;
    hirePeriodActual: number;
    hirePeriod: string;
    siteAddress: string;
    status: string;
    quantityTotal: number;
    quantityScheduled: number;
    scheduledDate: string;
    installationDate: string;
    offhireDate: string;
    pickupDate: string;
    paid: boolean;
    goAhead: boolean;
    accountTypeId: number;
    allowOnGoingHire: number;
    chargePublicHoliday: boolean;
    chargeShutdownPeriod: boolean;
    extraHours: number;
    callout: boolean;
    showRedNotes: boolean;
    copy: boolean;
    isDirty: boolean;
}

export default class ScheduleReadyItems extends React.Component<ScheduleItemsProps, ScheduleItems> {
    constructor(props: ScheduleItemsProps) {
        super(props);

        this.state = {
            loading: true,
            tab: "Install",
            items: [],
            siteAddressFilter: "",
            customerFilter: "",
            itemFilter: []
        }  
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();

        axios.get('api/Schedule/GetItemList', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ items: res.data, loading: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    tabSelected(tab: string) {
        this.setState({ tab: tab });
    }

    tabChanged = (e: any) => {
        this.tabSelected(e.target.value);
    }

    noChange = (e: any) => {
        //no changes as user doesn't actually click on the radio button
    }

    handleChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.value;
        this.setState(change);
    }

    handleMultiChange = (selected: MultiValue<OptionsItem>, actionMeta: ActionMeta<OptionsItem>) => {
        let results = [...selected];
        this.setState({ itemFilter: results });
    }

    updateSelected = (itemIndex: number) => {
        var scheduleItems = this.state.tab == "Install" ? this.props.install : this.props.pickup;
        var scheduledItem = scheduleItems[itemIndex];
        scheduledItem.selected = !scheduledItem.selected;

        if (this.state.tab == "Install") {
            this.props.updateInstalls({ install: scheduleItems });
        } else {
            this.props.updatePickups({ pickup: scheduleItems });
        }
    }

    updateShowDetail(rowIndex: number, showDetail: boolean) {
        //update show Detail from False to True and vice versa
        if (showDetail == null) {
            showDetail = true;
        } else {
            showDetail = !showDetail;
        }

        //update the row
        var scheduleItems = this.state.tab == "Install" ? this.props.install : this.props.pickup;

        //may need to filter the results
        let filteredscheduleItems = scheduleItems.filter(sch =>
            sch.scheduled != true
        );
        if (this.state.siteAddressFilter) {
            filteredscheduleItems = filteredscheduleItems.filter(sch =>
                sch.siteAddress.toLowerCase().indexOf(this.state.siteAddressFilter.toLowerCase()) > -1
            );
        }
        //show the items
        filteredscheduleItems[rowIndex].showDetail = showDetail;

        if (this.state.tab == "Install") {
            this.props.updateInstalls({ install: scheduleItems });
        } else {
            this.props.updatePickups({ pickup: scheduleItems });
        }

    }

    scheduleItems = () => {
        var installs = this.props.install;
        var pickups = this.props.pickup;
        var scheduledItems = this.props.scheduleItems;

        //add any selected installs
        for (var i = 0; i < installs.length; i++) {
            var dropsched = installs[i].scheduled ? installs[i].scheduled : false;
            if (installs[i].selected && dropsched == false) {

                var scheduleItem: ScheduleItem = {
                    origItemIndex: installs[i].itemIndex,
                    id: 0,
                    jobId: installs[i].jobId,
                    itemId: installs[i].itemId,
                    item: installs[i].item,
                    siteAddress: installs[i].siteAddress,
                    jobQuoteItemId: installs[i].jobQuoteItemId,
                    status: installs[i].status,
                    quantityTotal: installs[i].quantityTotal,
                    quantityScheduled: installs[i].quantityScheduled,
                    scheduledDate: "",
                    installationDate: "",
                    offhireDate: "",
                    pickupDate: "",
                    paid: false,
                    goAhead: false,
                    type: "Install",
                    typeId: 1,
                    hirePeriodActual: installs[i].hirePeriodActual,
                    hirePeriod: installs[i].hirePeriod,
                    accountTypeId: installs[i].accountTypeId,
                    allowOnGoingHire: installs[i].allowOnGoingHire,
                    chargePublicHoliday: installs[i].chargePublicHoliday,
                    chargeShutdownPeriod: installs[i].chargeShutdownPeriod,
                    callout: installs[i].callout,
                    showRedNotes: installs[i].showRedNotes,
                    extraHours: installs[i].extraHours,
                    copy: false,
                    isDirty: true
                };
                scheduledItems.push(scheduleItem);
                installs[i].scheduled = true;
            }
        }

        //add any selected pickups
        for (var i = 0; i < pickups.length; i++) {
            var picksched = pickups[i].scheduled ? pickups[i].scheduled : false;
            if (pickups[i].selected && picksched == false) {

                var scheduleItem: ScheduleItem = {
                    origItemIndex: pickups[i].itemIndex,
                    id: 0,
                    jobId: pickups[i].jobId,
                    itemId: pickups[i].itemId,
                    item: pickups[i].item,
                    siteAddress: pickups[i].siteAddress,
                    jobQuoteItemId: pickups[i].jobQuoteItemId,
                    status: pickups[i].status,
                    quantityTotal: pickups[i].quantityTotal,
                    quantityScheduled: pickups[i].quantityScheduled,
                    scheduledDate: "",
                    installationDate: "",
                    offhireDate: "",
                    pickupDate: "",
                    paid: false,
                    goAhead: false,
                    type: "Pick Up",
                    typeId: 2,
                    hirePeriodActual: pickups[i].hirePeriodActual,
                    hirePeriod: pickups[i].hirePeriod,
                    accountTypeId: pickups[i].accountTypeId,
                    allowOnGoingHire: pickups[i].allowOnGoingHire,
                    chargePublicHoliday: pickups[i].chargePublicHoliday,
                    chargeShutdownPeriod: pickups[i].chargeShutdownPeriod,
                    callout: pickups[i].callout,
                    showRedNotes: pickups[i].showRedNotes,
                    extraHours: pickups[i].extraHours,
                    copy: false,
                    isDirty: true
                };
                scheduledItems.push(scheduleItem);
                pickups[i].scheduled = true;
            }
        }

        this.props.save({ scheduledItems: scheduledItems });
    }

    render() {
        var scheduleItems = this.state.tab == "Install" ? this.props.install : this.props.pickup;
        let filteredscheduleItems = scheduleItems.filter(sch =>
            sch.scheduled != true
        );
        if (this.state.siteAddressFilter) {
            filteredscheduleItems = filteredscheduleItems.filter(sch =>
                sch.siteAddress.toLowerCase().indexOf(this.state.siteAddressFilter.toLowerCase()) > -1
            );
        }
        if (this.state.customerFilter) {
            filteredscheduleItems = filteredscheduleItems.filter(sch =>
                sch.customer.toLowerCase().indexOf(this.state.customerFilter.toLowerCase()) > -1
            );
        }
        if (this.state.itemFilter.length > 0) {
            filteredscheduleItems = filteredscheduleItems.filter(sch =>
                this.state.itemFilter.find(x => x.value === sch.itemId)
            );
        }

        return (
            <div className="tabsComponent" id="tab-container">

                <div className="tabsComponent__showDropdown">
                    <label className="input-group" htmlFor="scheduleTab">
                        <span className="label">Item Type</span>
                        <select className="select" id="scheduleTab" value={this.state.tab} onChange={this.tabChanged} >
                            <option value="Install">Install</option>
                            <option value="Pickup">Pick Up</option>
                        </select>
                    </label>
                </div>

                <div className="tabsComponent__tabs tabsComponent__hideTabs">
                    <input type="radio" name="tabs" id="tab1" className="tabsComponent__control" checked={this.state.tab == 'Install'} onChange={(e) => this.noChange(e)}></input>
                    <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => this.tabSelected('Install')}>Install</label>
                    <input type="radio" name="tabs" id="tab2" className="tabsComponent__control" checked={this.state.tab == 'Pickup'} onChange={(e) => this.noChange(e)}></input>
                    <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => this.tabSelected('Pickup')}>Pick Up</label>
                </div>

                <div className="tabsComponent__content tabsComponent__content--selected">
                    <div className="input-group-parent3">
                        <label className="input-group" htmlFor="siteAddressFilter">
                            <span className="label label-small">Site Address</span>
                            <input className="input" type="text" id="siteAddressFilter" name="siteAddressFilter" value={this.state.siteAddressFilter} onChange={(e) => this.handleChange(e)}></input>
                        </label>
                    </div>
                    <div className="input-group-parent3">
                        <label className="input-group" htmlFor="customerFilter">
                            <span className="label label-small">Customer</span>
                            <input className="input" type="text" id="customerFilter" name="customerFilter" value={this.state.customerFilter} onChange={(e) => this.handleChange(e)}></input>
                        </label>
                    </div>
                    <div className="input-group-parent3">
                        <label className="input-group" htmlFor="itemFilter">
                            <span className="label label-small">Item/s</span>
                            <Select className="selectmultiwidth" isMulti id="itemFilter" name="itemFilter" options={this.state.items} onChange={this.handleMultiChange} />
                        </label>
                    </div>
                    <div className={this.props.isModal ? "table__margin overflowAuto schedulenew__addNewSize" : "table__margin overflowAuto"}>
                        <table className="table table__large tableColours">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th className="hidden">Id</th>
                                    <th></th>
                                    <th>Job Id</th>
                                    <th>Site Address</th>
                                    <th>Customer</th>
                                    <th>Item</th>
                                    <th>Status</th>
                                    <th>Quantity</th>
                                    <th>Hire Period</th>
                                    <th>Notes</th>
                                </tr>
                            </thead>
                            {filteredscheduleItems.map((schedule, index) =>
                                <tbody key={index}>
                                    <tr>
                                        <td className="table__text--align"><button type="button" className={this.state.tab == "Install" && schedule.items.length > 0 ? "btn btn-default btn-sm" : "hidden"} onClick={() => this.updateShowDetail(index, schedule.showDetail)}><i className={"glyphicon glyphicon-plus" + (schedule.showDetail ? ' rotate45deg' : '')}></i></button></td>
                                        <td className="hidden">{schedule.itemId}</td>
                                        <td className="table__text--align"><input type='checkbox' className={((this.state.tab == "Install" && schedule.status == "Quoted") || this.state.tab == "Pickup") ? "input" : "hidden"} checked={schedule.selected} onChange={() => this.updateSelected(schedule.itemIndex)} /></td>
                                        <td className="table__text--align"> {schedule.jobId}</td>
                                        <td className="table__text--align"> {schedule.siteAddress.replace(", Australia", "")}</td>
                                        <td className="table__text--align"> {schedule.customer}</td>
                                        <td className="table__text--align">{schedule.item}</td>
                                        <td className="table__text--align">{schedule.status}</td>
                                        <td className="table__text--align">{schedule.quantityType}</td>
                                        <td className="table__text--align">{schedule.hirePeriod}</td>
                                        <td>
                                            <div className="tooltipitem tooltipitem__left">{schedule.notes ? schedule.notes.substring(0, 20) + "... " : ""}
                                                <span className="tooltipitemtext tooltipitemtext__left">{schedule.notes}</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className={(schedule.showDetail ? '' : 'row--hidden')}>
                                        <td colSpan={10}>
                                            <table className='table subtable'>
                                                <thead>
                                                    <tr>
                                                        <th>Id</th>
                                                        <th>Item</th>
                                                        <th>Status</th>
                                                        <th>Quantity</th>
                                                        <th>Hire Period</th>
                                                    </tr>
                                                </thead>
                                                {schedule.items.map((item, index) =>
                                                    <tbody key={index}>
                                                        <tr>
                                                            <td className="table__text--align">{item.jobQuoteItemId}</td>
                                                            <td className="table__text--align">{item.item}</td>
                                                            <td className="table__text--align">{item.status}</td>
                                                            <td className="table__text--align">{item.quantityType}</td>
                                                            <td className="table__text--align">{item.hirePeriod}</td>
                                                        </tr>
                                                    </tbody>
                                                )}
                                            </table>

                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>

                    </div>
                    <div className={this.props.isModal ? "hidden" : "row"}>
                        <button className="defaultbutton-next" onClick={this.scheduleItems} type="button">Schedule</button>
                    </div>
                </div>
            </div>
        );
    }

}